import { render, staticRenderFns } from "./ActivityWsVideoLooping.vue?vue&type=template&id=a870b416&scoped=true"
import script from "./ActivityWsVideoLooping.vue?vue&type=script&lang=ts"
export * from "./ActivityWsVideoLooping.vue?vue&type=script&lang=ts"
import style0 from "./ActivityWsVideoLooping.vue?vue&type=style&index=0&id=a870b416&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a870b416",
  null
  
)

/* custom blocks */
import block0 from "./ActivityWsVideoLooping.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

export default component.exports